import { ActivityReflection } from './activity-reflection'
import { ActivityTask } from './activity-task'
import { ReflectionTypeEnum } from './reflection-type-enum'
import { LoginTypeEnum } from './login-type-enum'
import { ActivityStatusTypeEnum } from './activity-status-type-enum'

export interface ActivityInterface {
  /**
   * 活动人数数量
   */
  reflectionCount?: number
  /**
   * 活动用户列表
   */
  activityReflections?: ActivityReflection[]
  /**
   * 活动任务列表
   */
  activityTasks?: ActivityTask[]
  /**
   * 活动是否有邀请码
   */
  hasInviteCode?: boolean
  name: string
  /**
   * 参与活动用户类型
   */
  reflectionType: ReflectionTypeEnum
  /**
   * 活动邀请限制人数
   */
  reflectionLimit?: number
  /**
   * 活动邀请码
   */
  inviteCode?: string | null
  /**
   * 活动活动登录类型
   */
  loginType: LoginTypeEnum
  /**
   * 活动状态
   */
  status: ActivityStatusTypeEnum
  /**
   * 个性化logo
   */
  logo?: string | null
  /**
   * 背景图
   */
  bgImage?: string | null
  /**
   * 主题色
   */
  themeColor?: string | null
  /**
   * 活动管理员
   */
  adminIds?: number[]
  /**
   * 描述
   */
  description?: string
  /**
   * 活动开始时间
   */
  startedAt?: string | null
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class Activity implements ActivityInterface {
  /**
   * 活动人数数量
   */
  reflectionCount?: number
  /**
   * 活动用户列表
   */
  activityReflections?: ActivityReflection[]
  /**
   * 活动任务列表
   */
  activityTasks?: ActivityTask[]
  /**
   * 活动是否有邀请码
   */
  hasInviteCode?: boolean
  name: string
  /**
   * 参与活动用户类型
   */
  reflectionType: ReflectionTypeEnum
  /**
   * 活动邀请限制人数
   */
  reflectionLimit?: number
  /**
   * 活动邀请码
   */
  inviteCode?: string | null
  /**
   * 活动活动登录类型
   */
  loginType: LoginTypeEnum
  /**
   * 活动状态
   */
  status: ActivityStatusTypeEnum
  /**
   * 个性化logo
   */
  logo?: string | null
  /**
   * 背景图
   */
  bgImage?: string | null
  /**
   * 主题色
   */
  themeColor?: string | null
  /**
   * 活动管理员
   */
  adminIds?: number[]
  /**
   * 描述
   */
  description?: string
  /**
   * 活动开始时间
   */
  startedAt?: string | null
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: ActivityInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      reflectionCount: _reflectionCount,
      activityReflections: _activityReflections,
      activityTasks: _activityTasks,
      hasInviteCode: _hasInviteCode,
      name: _name,
      reflectionType: _reflectionType,
      reflectionLimit: _reflectionLimit,
      inviteCode: _inviteCode,
      loginType: _loginType,
      status: _status,
      logo: _logo,
      bgImage: _bgImage,
      themeColor: _themeColor,
      adminIds: _adminIds,
      description: _description,
      startedAt: _startedAt,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.reflectionCount = _reflectionCount
    this.activityReflections = _activityReflections
      ? _activityReflections.map((i) => new ActivityReflection(i))
      : _activityReflections
    this.activityTasks = _activityTasks
      ? _activityTasks.map((i) => new ActivityTask(i))
      : _activityTasks
    this.hasInviteCode = _hasInviteCode
    this.name = _name
    this.reflectionType = _reflectionType
    this.reflectionLimit = _reflectionLimit
    this.inviteCode = _inviteCode
    this.loginType = _loginType
    this.status = _status
    this.logo = _logo
    this.bgImage = _bgImage
    this.themeColor = _themeColor
    this.adminIds = _adminIds
    this.description = _description
    this.startedAt = _startedAt
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
